import { assetFolders } from 'common/constants'
import { Modal } from 'react-bootstrap'
import styled from 'styled-components'

export const StyledConfirmModal = styled(Modal)`
  min-width: 700px;

  .modal-content {
    width: fit-content;
  }

  .modal-body {
    width: 512px;
    padding: 1rem 1.5rem;
  }

  .modal-title {
    font-size: 13px;
    text-transform: uppercase;
    text-shadow: 0 0 1px rgba(0, 0, 0, 0.6);
  }

  .modal-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 1.5rem 0;
    border-bottom: none;
    /* margin: 8px 0px; */
  }

  .modal-final-sale {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 42px;

    label {
      text-transform: uppercase;
      font-weight: bolder;
      color: #c3002f;
    }

    img {
      transform: scale(0.6) translateY(-6px) translateX(12px);
    }
  }

  .modal-btn-group {
  }
`

export const StyledButtonContainer = styled.div<{ assetFolder?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 26px;
  /* margin-top: 1.5rem; */

  .btn-popup {
    border-radius: 2px;
    color: #fff;
    font-size: 11px;
    text-align: center;
    padding: 0.57143em 1.42857em 0.35714em;
    padding-top: 0.57143em;
    padding-bottom: 0.35714em;
    cursor: pointer;
    width: 390px;
    height: 46px;
    line-height: 12px;
    white-space: normal;
    word-wrap: break-word;
    text-transform: uppercase;
    border: none;
  }

  .btn-neglect {
    padding-left: 34px;
    padding-right: 49px;
    background-color: ${({ assetFolder }) => (assetFolder === assetFolders.Infiniti ? '#606060' : '#c3002f')};
    border: ${({ assetFolder }) => assetFolder === assetFolders.Infiniti && 'solid 1.5px black'};
  }

  .btn-neglect:hover {
    background-color: ${({ assetFolder }) => (assetFolder === assetFolders.Infiniti ? '#ccc' : '#a50129')};
    color: ${({ assetFolder }) => assetFolder === assetFolders.Infiniti && '#666'};
  }

  .btn-confirm {
    padding-left: 31px;
    padding-right: 13px;
    background-color: ${({ assetFolder }) => (assetFolder === assetFolders.Infiniti ? 'white' : '#508f40')};
    color: ${({ assetFolder }) => assetFolder === assetFolders.Infiniti && 'black'};
    border: ${({ assetFolder }) => assetFolder === assetFolders.Infiniti && 'solid 1.5px black'};
  }

  .btn-confirm:hover {
    background-color: ${({ assetFolder }) => (assetFolder === assetFolders.Infiniti ? '#000' : '#327322')};
    color: ${({ assetFolder }) => assetFolder === assetFolders.Infiniti && '#fff'};
  }
`
